import { render, staticRenderFns } from "./RelatedProductTile.vue?vue&type=template&id=17c5e247&scoped=true&"
import script from "./RelatedProductTile.vue?vue&type=script&lang=js&"
export * from "./RelatedProductTile.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProductTile.vue?vue&type=style&index=0&id=17c5e247&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c5e247",
  null
  
)

export default component.exports